import React, { useEffect, useState, useContext, useRef, useMemo } from "react";
import { Card } from 'primereact/card';
import { Skeleton } from 'primereact/skeleton';
import { useWeb3React } from "@web3-react/core";
import { TabView, TabPanel } from 'primereact/tabview';


import { SelectButton } from 'primereact/selectbutton';

import { Popover, Table, Tooltip as TooltipNext, Button as RevealButton, Progress } from '@nextui-org/react';
import Web3 from "web3";

import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';

import ContractContext from '../../ContractContext'; //Required for all dApp components using contracts

import {
    infoOutlineStyle, cardOutlineHeaderStyle, cardOutlineStyle, miniCardHeaderOutlineStyle, miniInfoOutlineStyle,
    infoOutlineInvertStyle, cardOutlineInvertHeaderStyle, cardOutlineInvertStyle, miniCardHeaderStyle, miniInfoStyle,
    infoStyle, cardStyle, cardHeaderInvertStyle, miniCardHeaderInvertStyle, miniInfoInvertStyle, cardHeaderStyle, cardOutlineSmallStyle
} from "./TileStyles";

import { formatTokenLabel, formatCurrencyExtended, abbreviateNumber, formatTokenIcon, formatDecimals, } from '../../utils';

import BigNumber from 'bignumber.js';

import { PieChart, Pie, Sector, Cell, ResponsiveContainer } from 'recharts';

import { useInView } from 'react-intersection-observer';

import { DefiAppService } from "../../DefiAppService";
import { get } from "https-browserify";

const DashboardModuleEcosystemSummary = ({ data, getData, rocketFiPrice }) => {

    const { library, account } = useWeb3React();
    const contractContext = useContext(ContractContext);
    const contracts = contractContext.contracts;
    const isWalletConnected = () => account !== null;

    const toast = useRef(null);

    const LoadingContent = () => <Skeleton width="50%" height="35px" className="mb-2" />;
    const LoadingTitle = () => <Skeleton width="25%" height="25px" className="mb-2" />;



    useEffect(() => {
        //console.log("RocketFi-Dashboard data", data);
    }, [data]);


    const calculateTotalEarnedByVersion = (tokensList) => {
        let totalEarned = new BigNumber(0);

        if (data && tokensList) {
            tokensList.forEach(token => {
                if (token.price && (token.unclaimedAmount > 0 || token.claimedAmount > 0)) {
                    const value = new BigNumber(token.unclaimedAmount)
                        .plus(token.claimedAmount)
                        .times(token.price)
                        .div(new BigNumber(10).pow(token.decimals));

                    totalEarned = totalEarned.plus(value);
                }
            });
        }

        return totalEarned.isNaN() ? 0 : totalEarned.toNumber();
    };

    const calculateTotalEarnedRocketFiByVersion = (tokensList) => {
        let totalEarned = new BigNumber(0);

        //where tokensList token is RocketFi where address is "0x6e61579c22F9a6dA63a33e819f29B6697d2a126E"
        if (data && tokensList) {
            tokensList.find(token => {
                if (token.address === "0x6e61579c22F9a6dA63a33e819f29B6697d2a126E") {
                    if (token.price && (token.unclaimedAmount > 0 || token.claimedAmount > 0)) {
                        const value = new BigNumber(token.unclaimedAmount)
                            .plus(token.claimedAmount)
                            .times(token.price)
                            .div(new BigNumber(10).pow(token.decimals));

                        totalEarned = totalEarned.plus(value);
                    }
                }
            });
        }

        return totalEarned.isNaN() ? 0 : totalEarned.toNumber();
    };

    const [includeAllRewards, setIncludeAllRewards] = useState(true);


    const calculateRocketFiUSD = (amount) => {
        if (!rocketFiPrice || amount <= 0) return 0;
        const calculatedPrice = new BigNumber(amount)
            .times(rocketFiPrice)
            .div(new BigNumber(10).pow(9))

        return calculatedPrice.isNaN() ? 0 : calculatedPrice.toNumber();
    };
    const getTotalEarnedSmartRewards = () => {
        return includeAllRewards ?
            calculateTotalEarnedByVersion(data?.tokensList) + calculateTotalEarnedByVersion(data?.tokensListV2) + calculateTotalEarnedByVersion(data?.tokensListV1)
            : calculateTotalEarnedRocketFiByVersion(data?.tokensList) + calculateTotalEarnedRocketFiByVersion(data?.tokensListV2) + calculateTotalEarnedRocketFiByVersion(data?.tokensListV1)
    };

    const getTotalEarnedRewardPacks = () => {
        return includeAllRewards ?
            calculateTotalEarnedByVersion(data?.tokensListRp)
            : calculateTotalEarnedRocketFiByVersion(data?.tokensListRp)
    };

    const getTotalEarnedBurnRewards = () => {
        return calculateRocketFiUSD(data?.contractData?.burnData?.totalRocketFiRewarded)
            + calculateRocketFiUSD(data?.contractData?.burnData?.totalRealisedUndeposited)
            + calculateRocketFiUSD(data?.contractData?.burnData?.unclaimedRocketFi)
    };

    const getTotalEarnedBoostRewards = () => {
        return calculateRocketFiUSD(data?.contractData?.playData?.totalBoostPoolEarnings)
            + calculateRocketFiUSD(data?.contradtData?.playData?.availableBoostPoolEarningsToClaim)
    };

    const chartData = [
        {
            name: 'Burn',
            value: getTotalEarnedBurnRewards()
        },
        {
            name: 'Boost',
            value: getTotalEarnedBoostRewards()
        },
        {
            name: 'Smart',
            value: getTotalEarnedSmartRewards()
        },
        {
            name: 'Reward Packs',
            value: getTotalEarnedRewardPacks()
        }
    ];

    const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];

    const RADIAN = Math.PI / 180;
    const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
        const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
        const x = cx + radius * Math.cos(-midAngle * RADIAN);
        const y = cy + radius * Math.sin(-midAngle * RADIAN);

        return (
            <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
                {`${(percent * 100).toFixed(0)}%`}
            </text>
        );
    };




    const getTotalEcosystemBalanceUSD = () => {
        return getTotalEarnedBurnRewards() + getTotalEarnedBoostRewards() + getTotalEarnedSmartRewards() + getTotalEarnedRewardPacks();
    };

    const options = ['All Rewards','RocketFi Only'];
    const [value, setValue] = useState(options[0]);
    const [isClaiming, setIsClaiming] = useState(false);
    const [isRewardClaiming, setIsRewardClaiming] = useState(false);

    useEffect(() => {
        if (value === options[1]) {
            setIncludeAllRewards(false);
        } else {
            setIncludeAllRewards(true);
        }
    }, [value]);


    const handleClaim = async () => {
        setIsClaiming(true);
        if (!isWalletConnected()) {
            console.error("Please connect to a wallet before interacting with the contract.");
            return;
        }
        if (!contracts.rocketFuel) {
            console.error("RocketFuel contract not available.");
            return;
        }

        console.log("RocketFuel: Claim Rewards button clicked");

        try {
            const transaction = contracts.rocketFuel.methods.claimDividends().send({ from: account });

            transaction.on("transactionHash", (hash) => {
                toast.current.show({ severity: 'info', summary: 'Transaction Submitted', detail: `Transaction Hash: ${hash}. Follow the transaction on BscScan here: https://bscscan.com/tx/${hash}`, life: 3000 });
            });

            const tx = await transaction;

            toast.current.show({ severity: 'success', summary: 'Transaction Success', detail: 'The transaction has been completed successfully.', life: 3000 });

        } catch (error) {
            console.error("Error interacting with the Rocket Fuel contract:", error);
            toast.current.show({ severity: 'error', summary: 'Transaction Error', detail: `Error interacting with the Rocket Fuel contract: ${error.message}`, life: 3000 });
        }

        getData();
        setIsClaiming(false);
    };

    const handleClaimRewards = async () => {
        setIsRewardClaiming(true);
        if (!isWalletConnected()) {
            console.error("Please connect to a wallet before interacting with the contract.");
            return;
        }
        if (!contracts.rocketPlay) {
            console.error("RocketFuel contract not available.");
            return;
        }

        console.log("RocketPlay: Claim Rewards button clicked");

        try {
            const transaction = contracts.rocketPlay.methods.claimRewards().send({ from: account });

            transaction.on("transactionHash", (hash) => {
                toast.current.show({ severity: 'info', summary: 'Transaction Submitted', detail: `Transaction Hash: ${hash}. Follow the transaction on BscScan here: https://bscscan.com/tx/${hash}`, life: 3000 });
            });

            const tx = await transaction;

            toast.current.show({ severity: 'success', summary: 'Transaction Success', detail: 'The transaction has been completed successfully.', life: 3000 });

        } catch (error) {
            console.error("Error interacting with the Rocket Fuel contract:", error);
            toast.current.show({ severity: 'error', summary: 'Transaction Error', detail: `Error interacting with the Rocket Fuel contract: ${error.message}`, life: 3000 });
        }

        getData();
        setIsRewardClaiming(false);
    };

    return (
        <Card title={"Ecosystem Earnings"} style={cardOutlineSmallStyle}>
            <div style={{ marginTop: "10px" }}>
                <>


                    <div>
                        <div style={{ marginTop: "15px" }}>
                            Total {includeAllRewards ? '' : 'RocketFi'} Earned
                        </div>
                        <div style={infoStyle}>
                            {data?.tokensList !== undefined
                                ? formatCurrencyExtended(getTotalEcosystemBalanceUSD()
                                )
                                : LoadingContent()
                            }
                        </div>
                    </div>
                    <div>
                        <SelectButton value={value} onChange={(e) => setValue(e.value)} options={options}
                            style={{ width: '100%', justifyContent: 'center', marginTop: '10px' }} />
                    </div>

                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(115px, 1fr))', gap: '10px', marginTop: '10px' }}>
                        <div>
                            <div style={{ ...miniCardHeaderStyle, marginTop: "15px" }}>
                                Fuel Rewards
                            </div>
                            <div style={miniInfoStyle}>
                                {data?.contractData !== undefined
                                    ? formatCurrencyExtended(getTotalEarnedBurnRewards()
                                    )
                                    : LoadingContent()
                                }
                            </div>
                        </div>
                        <div>
                            <div style={{ ...miniCardHeaderStyle, marginTop: "15px" }}>
                                Boost Rewards
                            </div>
                            <div style={miniInfoStyle}>
                                {data?.contractData !== undefined
                                    ? formatCurrencyExtended(getTotalEarnedBoostRewards()
                                    )
                                    : LoadingContent()
                                }
                            </div>
                        </div>
                        {getTotalEarnedSmartRewards() > 0 && <div>
                            <div style={{ ...miniCardHeaderStyle, marginTop: "15px" }}>
                                Smart Rewards
                            </div>
                            <div style={miniInfoStyle}>
                                {data?.tokensList !== undefined
                                    ? formatCurrencyExtended(getTotalEarnedSmartRewards()
                                    )
                                    : LoadingContent()
                                }
                            </div>
                        </div>}
                        <div>
                            <div style={{ ...miniCardHeaderStyle, marginTop: "15px" }}>
                                Reward Packs
                            </div>
                            <div style={miniInfoStyle}>
                                {data?.tokensListRp !== undefined
                                    ? formatCurrencyExtended(getTotalEarnedRewardPacks()
                                    )
                                    : LoadingContent()
                                }
                            </div>
                        </div>

                    </div>

                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))', gap: '10px', marginTop: '10px' }}>

                        {//data?.contractData?.burnData && data.contractData.burnData.totalRealisedUndeposited + data.contractData.burnData.unclaimedRocketFi > 0 && 
                            data?.contractData?.burnData &&
                            <div>
                                <div style={{ ...miniCardHeaderStyle, marginTop: "15px" }}>
                                    Pending Fuel Rewards
                                </div>
                                <>
                                    {(
                                        isClaiming ? <div style={{ width: '100%', justifyContent: 'center', marginTop: '10px' }}><Progress
                                            indeterminated
                                            color="gradient"
                                            status="secondary"
                                            size="xl"

                                        /></div> : <>
                                            <Button
                                                onClick={handleClaim}
                                                rounded
                                                severity="warning"
                                                size="small"
                                                style={{ width: '150px', justifyContent: 'center', marginTop: '10px' }}
                                                disabled={(parseFloat(data.contractData.burnData.totalRealisedUndeposited) + parseFloat(data.contractData.burnData.unclaimedRocketFi)) === 0}
                                            >
                                                {formatTokenIcon(data.dbData, "0x6e61579c22F9a6dA63a33e819f29B6697d2a126E")}
                                                {formatDecimals((parseFloat(data.contractData.burnData.totalRealisedUndeposited) + parseFloat(data.contractData.burnData.unclaimedRocketFi)), 9)}
                                                {' (' + formatCurrencyExtended(((parseFloat(data.contractData.burnData.totalRealisedUndeposited) + parseFloat(data.contractData.burnData.unclaimedRocketFi)) / (10 ** 9)) * rocketFiPrice) + ')'}

                                            </Button>
                                        </>)
                                    }
                                </>
                            </div>
                        }
                        {//data?.contractData?.playData && data.contractData.playData.availableBoostPoolEarningsToClaim > 0 &&
                            data?.contractData?.playData &&
                            <div>
                                <div style={{ ...miniCardHeaderStyle, marginTop: "15px" }}>
                                    Pending Boost Rewards
                                </div>
                                <>{
                                    (
                                        isRewardClaiming ? <div style={{ width: '100%', justifyContent: 'center', marginTop: '10px' }}><Progress
                                            indeterminated
                                            color="gradient"
                                            status="secondary"
                                            size="xl"

                                        /></div> : <>
                                            <Button
                                                onClick={handleClaimRewards}
                                                rounded
                                                severity="warning"
                                                size="small"
                                                style={{ width: '150px', justifyContent: 'center', marginTop: '10px' }}
                                                disabled={parseFloat(data.contractData.playData.availableBoostPoolEarningsToClaim) === 0}
                                            >

                                                {formatTokenIcon(data.dbData, "0x6e61579c22F9a6dA63a33e819f29B6697d2a126E")}
                                                {formatDecimals(parseFloat(data.contractData.playData.availableBoostPoolEarningsToClaim), 9)}
                                                {' (' + formatCurrencyExtended(((parseFloat(data.contractData.playData.availableBoostPoolEarningsToClaim)) / (10 ** 9)) * rocketFiPrice) + ')'}
                                            </Button>
                                        </>)}</>

                            </div>}
                    </div>

                    {/* <PieChart width={400} height={400}>
                        <Pie
                            data={chartData}
                            cx={200}
                            cy={200}
                            labelLine={false}
                            label={renderCustomizedLabel}
                            outerRadius={80}
                            fill="#8884d8"
                            dataKey="value"
                        >
                            {chartData.map((entry, index) => (
                              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                            ))}
                        </Pie>
                    </PieChart> */}
                </>
            </div>
            <Toast ref={toast} />
        </Card>
    );
}

export default React.memo(DashboardModuleEcosystemSummary);
